export const GET_FILES__REQUEST = 'FILES_TYPE__GET_FILES__REQUEST'
export const GET_FILES__FAILURE = 'FILES_TYPE__GET_FILES__FAILURE'
export const GET_FILES__SUCCESS = 'FILES_TYPE__GET_FILES__SUCCESS'
export const GET_FILE__REQUEST = 'FILES_TYPE__GET_FILE__REQUEST'
export const GET_FILE__FAILURE = 'FILES_TYPE__GET_FILE__FAILURE'
export const GET_FILE__SUCCESS = 'FILES_TYPE__GET_FILE__SUCCESS'
export const UPLOAD_FILE__REQUEST = 'FILES_TYPE__UPLOAD_FILE__REQUEST'
export const UPLOAD_FILE__FAILURE = 'FILES_TYPE__UPLOAD_FILE__FAILURE'
export const UPLOAD_FILE__SUCCESS = 'FILES_TYPE__UPLOAD_FILE__SUCCESS'
